import { FC, ReactNode } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { buttonVariants } from '@clatter/ui';
import { NgButton } from '../UI';

interface Props {
  open: boolean;
  title: string;
  message: string;
  details?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const NgConfirmDialog: FC<Props> = ({
  open,
  title,
  message,
  details,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
        {details}
      </DialogContent>
      <DialogActions>
        <NgButton variant={buttonVariants.clear} onClick={onCancel}>
          {cancelLabel}
        </NgButton>
        <NgButton variant={buttonVariants.primary} onClick={onConfirm}>
          {confirmLabel}
        </NgButton>
      </DialogActions>
    </Dialog>
  );
};
